/** Display names of countries and ISO 3166-2 regions (US states, Canadian provinces); others show their code. */
const NAMES: Record<string, string> = {
  "US-AL": "Alabama", "US-AK": "Alaska", "US-AZ": "Arizona", "US-AR": "Arkansas", "US-CA": "California", "US-CO": "Colorado",
  "US-CT": "Connecticut", "US-DE": "Delaware", "US-DC": "District of Columbia", "US-FL": "Florida", "US-GA": "Georgia",
  "US-HI": "Hawaii", "US-ID": "Idaho", "US-IL": "Illinois", "US-IN": "Indiana", "US-IA": "Iowa", "US-KS": "Kansas",
  "US-KY": "Kentucky", "US-LA": "Louisiana", "US-ME": "Maine", "US-MD": "Maryland", "US-MA": "Massachusetts",
  "US-MI": "Michigan", "US-MN": "Minnesota", "US-MS": "Mississippi", "US-MO": "Missouri", "US-MT": "Montana",
  "US-NE": "Nebraska", "US-NV": "Nevada", "US-NH": "New Hampshire", "US-NJ": "New Jersey", "US-NM": "New Mexico",
  "US-NY": "New York", "US-NC": "North Carolina", "US-ND": "North Dakota", "US-OH": "Ohio", "US-OK": "Oklahoma",
  "US-OR": "Oregon", "US-PA": "Pennsylvania", "US-RI": "Rhode Island", "US-SC": "South Carolina", "US-SD": "South Dakota",
  "US-TN": "Tennessee", "US-TX": "Texas", "US-UT": "Utah", "US-VT": "Vermont", "US-VA": "Virginia", "US-WA": "Washington",
  "US-WV": "West Virginia", "US-WI": "Wisconsin", "US-WY": "Wyoming", "US-PR": "Puerto Rico",
  "CA-AB": "Alberta", "CA-BC": "British Columbia", "CA-MB": "Manitoba", "CA-NB": "New Brunswick",
  "CA-NL": "Newfoundland and Labrador", "CA-NS": "Nova Scotia", "CA-NT": "Northwest Territories", "CA-NU": "Nunavut",
  "CA-ON": "Ontario", "CA-PE": "Prince Edward Island", "CA-QC": "Quebec", "CA-SK": "Saskatchewan", "CA-YT": "Yukon",
};

/** Region names are proper names: kept in English (Intl has no names for subdivisions). Country names come from Intl in
 * the reader's language (`locale`, from `useIntl().locale`); English without one. */
const countryNames = new Map<string, Intl.DisplayNames | null>();
function displayNames(locale: string): Intl.DisplayNames | null {
  if (!countryNames.has(locale)) {
    try {
      countryNames.set(locale, new Intl.DisplayNames([locale, "en"], { type: "region" }));
    } catch {
      countryNames.set(locale, null);
    }
  }
  return countryNames.get(locale) ?? null;
}

export function countryName(code: string, locale = "en"): string {
  if (code === "GB" && locale.startsWith("en")) return "Great Britain";
  return displayNames(locale)?.of(code) ?? code;
}

export function regionName(code: string): string {
  return NAMES[code] ?? code;
}

/** "California", "British Columbia, Alberta", "Great Britain" (whole country); lists in the reader's language. */
export function servedWhere(country: string, regions: string[], locale = "en"): string {
  if (!regions.length) return countryName(country, locale);
  const names = regions.map(regionName);
  let list: (items: string[]) => string;
  try {
    const format = new Intl.ListFormat(locale, { type: "unit", style: "short" });
    list = (items) => format.format(items);
  } catch {
    list = (items) => items.join(", ");
  }
  return names.length > 3 ? `${list(names.slice(0, 3))} +${names.length - 3}` : list(names);
}
